module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-E-window-background.7f5efcd2.png";